// Nama, hari, bulan, dan label elemen untuk cerita soal.
import { shuffle, R } from '../../core/random.js';
import { esc } from '../../core/format.js';

export const HARI=['Senin','Selasa','Rabu','Kamis','Jumat','Sabtu','Minggu'];
export const BULAN=['Januari','Februari','Maret','April','Mei','Juni','Juli','Agustus','September','Oktober','November','Desember'];
export const HARI_BULAN=[31,28,31,30,31,30,31,31,30,31,30,31];
export const ANAK=['Rina','Dika','Siti','Budi','Ayu','Fajar','Nisa','Bayu','Lala','Doni','Putri','Raka','Wulan','Andi','Sari','Bima','Citra','Gilang','Intan','Kirana','Nanda','Tegar','Zahra','Made','Rizki','Dewi','Yusuf','Mae','Desti','Ucok'];
export const DEWASA=['Pak Bondan','Bu Anita','Pak Bakri','Bu Rina','Pak Bayu','Bu Sri','Pak Hasan','Bu Dewi','Pak Joko','Bu Ningsih','Pak Made','Bu Tari'];
export const SEKOLAH=['Harapan','Mutiara','Cerdas','Pelita','Mentari','Tunas Bangsa','Bina Ilmu','Nusantara','Ceria','Pelangi'];
// Nama pemain sesekali dijadikan tokoh cerita supaya soal terasa milik sendiri.
let PEMAIN = '';
export function setPemain(nama) { PEMAIN = nama ? esc(String(nama).trim().split(/\s+/)[0].slice(0, 20)) : ''; }
export const names=k=>{
  const arr=shuffle(ANAK.filter(n=>n!==PEMAIN)).slice(0,k);
  if(PEMAIN&&Math.random()<0.3)arr[R(0,k-1)]=PEMAIN;
  return arr;
};
export const BIL='Bilangan',GEO='Geometri & Pengukuran',DAT='Data';
export const verdict=v=>`<b>${v?'Benar':'Salah'}</b>`;
